import React, { useState, useEffect} from "react";
import { fetchUIConfigData, getMetaData } from "../../../services/uiConfigService";
import { KPI_REVIEW_CONFIG_NAME } from "../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKPIReviewRegistry";
import "../../../features/salescodeStudio/mandatoryConfigs/mandatoryConfigCommon.css";
import {
  getDefaultConfigArray,
  isKPIConfigAllowed,
  getAllAllowedKPIsID,
  checkForDataFieldValidation,
  prepareDataForSaving,
  formatDataWithoutFasleShow,
  saveKPIReviewData
} from "../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";
import KPIFilter from "./kpiFilter/KPIFilter";
import KPIConfigAndPreview from "./kpiConfigAndPreview/KPIConfigAndPreview";
import "./manageKPIReviewConfig.css";
import { InputFieldLengthValidationType } from "../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKPIType";

type Props = {
    name:string,
    values:any,
    setValues: React.Dispatch<React.SetStateAction<any>>,
    defaultValues:any,
    setAreDataFieldsValid?:(isValid: boolean) => void;
}
const ManageKPIReviewCustom= (props:Props) => {
  const [areInputFieldsValid, setAreInputFieldsValid] = useState<boolean>(true);
  const [userConfig, setUserConfig] = useState<Array<Record<string, any>>>([]);
  const [selectedKPIsKeys, setSelectedKPIsKeys] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [values,setValues]=useState<any>({})
   const [hasActiveChild, setHasActiveChild] = useState(false);
  const [defaultConfigGlobal, setDefaultConfigGlobal] = useState<any>( {} );
  const inputLengthValidation:InputFieldLengthValidationType= {
          max:25,
          min:3
        }
  const getData = async () => {
    // console.log("get data called ")
    setLoading(true);
    try {
      // Fetch user-selected metadata
      // Extract saved configuration
      const savedConfig = props.values?.kpiConfigList?.value??[]
      // console.log("recived this -> ", savedConfig);
      // Prepare default configuration
      const defaultConfig: Record<string, any>[] =getDefaultConfigArray(props.defaultValues);
      // Extract selected keys before merging the savedconfig with default info
      const selectedKeys: string[] = savedConfig.map((element:any) => element.id);
      /* if element.id belong to selectedkeys then use savedConfig data , else use defaultConfig data  */
      const userConfigTemp = defaultConfig.reduce(
        (acc: Record<string, any>[], kpi: Record<string, any>) => {
          const element =
            (selectedKeys.includes(kpi.id)
              ? savedConfig.find((_kpi:any) => _kpi.id == kpi.id)
              : kpi) || kpi;
          const curKpi: Record<string, any> = {
            id: element.id,
            title: element.title,
          };
          const istakingDataFromSaved = savedConfig.some(
            (_kpi:any) => _kpi.id == kpi.id
          );
          // Conditionally add data_points and buttons if it exists
          if (
            element.detail_summary?.find(
              (item: Record<string, any>) => item.id === "toggleListView"
            )
          ) {
            curKpi.buttons = element.detail_summary?.find(
              (item: Record<string, any>) => item.id === "toggleListView"
            )?.toggle_list;
          }
          if (element.data_points) {
            //if taking datapoint from the saved config then take all , else take the first 3
            const allDataPoints = element?.data_points || [];
            curKpi.data_points = istakingDataFromSaved
              ? element?.data_points
              : element?.data_points?.splice(
                0,
                Math.min(3, allDataPoints.length)
              );
          }

          acc.push(curKpi);

          return acc;
        },
        []
      );
      setUserConfig(userConfigTemp);
      /*
       * if the user enters at the page for the first time , i.e the recived config will be empty , so we will add all the kpis to the selected keys
       */
      if (selectedKeys.length === 0) {
        setSelectedKPIsKeys(getAllAllowedKPIsID(defaultConfigGlobal));
      } else {
        setSelectedKPIsKeys(selectedKeys);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
 
  const handleSave = () => {
      if (!areInputFieldsValid)
        return;
      //saving this config <|>
      const configToSave: Record<string, any>[] = prepareDataForSaving(
        userConfig,
        selectedKPIsKeys,
        defaultConfigGlobal
      );
  
      const ans = formatDataWithoutFasleShow(configToSave);
      //TODO: apply the new flow code here ...
      // console.log("saved this -> ",ans);
     return ans;
    };

  const updateUserConfig = (_id: string, _kpi: Record<string, any>) => {
    const newUserConfig = userConfig.map((kpi) =>
      kpi.id === _id ? _kpi : kpi
    );
    setUserConfig(newUserConfig);
  };

  useEffect(() => {
    const check=checkForDataFieldValidation(userConfig, selectedKPIsKeys, inputLengthValidation)
    setAreInputFieldsValid(check)
    if(props.setAreDataFieldsValid)
    props.setAreDataFieldsValid(check)
    if(check){
    const ans=handleSave()
    props.setValues({
        ...props.values,
        kpiConfigList:{
            ...props.values["kpiConfigList"],
            value:ans,
            isValueUpdated:true
        }
    })
    }
  }, [userConfig, selectedKPIsKeys]);
   

useEffect(() => {
    setDefaultConfigGlobal(props.defaultValues)
    getData();
  }, [])

  return (
          <>
            <KPIFilter
              defaultConfigGlobal={defaultConfigGlobal}
              userConfig={userConfig}
              selectedKPIsKeys={selectedKPIsKeys}
              setSelectedKPIsKeys={setSelectedKPIsKeys}
            />
            {selectedKPIsKeys.length > 0 && (
              <KPIConfigAndPreview
                selectedKPIsKeys={selectedKPIsKeys}
                setSelectedKPIsKeys={setSelectedKPIsKeys}
                userConfig={userConfig}
                updateUserConfig={updateUserConfig}
                inputLengthValidation={inputLengthValidation}
                defaultConfigGlobal={defaultConfigGlobal}
              />
            )}
          </>
  );
}
export default ManageKPIReviewCustom;
